import { render, staticRenderFns } from "./VdoSetTopicEdit.vue?vue&type=template&id=33914d0c&scoped=true&"
import script from "./VdoSetTopicEdit.vue?vue&type=script&lang=js&"
export * from "./VdoSetTopicEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33914d0c",
  null
  
)

export default component.exports